export default {
  not_started: 'Skonfiguruj konto wypłat — udział w przychodach jest wstrzymany do czasu weryfikacji.',
  bank_account_missing:
    'Dodaj konto bankowe do wypłat — udział w przychodach jest wstrzymany, dopóki tego nie zrobisz.',
  incomplete:
    'Twoje konto wypłat nie jest jeszcze w pełni zweryfikowane — udział w przychodach jest wstrzymany do tego czasu.',
  add_bank_account: 'Dodaj konto bankowe',
  cta: 'Dokończ konfigurację',
};
